import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import usePageLoader from "../../Redux/hooks/usePageLoader";
import { useDispatch } from "react-redux";
import { updatePassword } from "../../Redux/Actions/AuthUser";
import ErrorHandler from "../../lib/errorHandler";
import CommonAuth from "../../Component/Common/CommonAuth";
import CommonTextField from "../../Component/Common/CommonTextField";
import ErrorMessage from "../../Component/Common/ErrorMessage";

const EnterPassword = () => {
    // =================== Hooks ===================
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const navigate = useNavigate();
    const location = useLocation();

    // =================== States ===================
    const [values, setValues] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");

    // =================== Handler ===================
    const handleBack = () => {
        navigate(`/login`);
    };

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
        setErrors({
            ...errors,
            [name]: "",
        });
    };

    // =================== validation ===================
    const validation = () => {
        let flag = false;
        let errors = {};

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!values.newPassword) {
            errors.newPassword = "Password is required";
            flag = true;
        } else if (!passwordRegex.test(values.newPassword)) {
            errors.newPassword =
                "Password must be at least 8 characters, include an uppercase letter, a lowercase letter, a number, and a special character";
            flag = true;
        }
        if (!values.confirmPassword) {
            errors.confirmPassword = "Password confirmation is required";
            flag = true;
        } else if (values.confirmPassword !== values.newPassword) {
            errors.confirmPassword = "Passwords do not match";
            flag = true;
        }

        setErrors(errors);
        return flag;
    };

    // =================== FotgotPassword API ===================
    const handleChangePassword = async () => {
        if (validation()) {
            return;
        }
        setFullPageLoader(true);
        let body = {
            password: values.newPassword,
            email: email,
            otp: otp,
        }
        let response = await dispatch(updatePassword(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setFullPageLoader(false);
            setSnackBar("success", `Password reset successfully`)
            navigate(`/login`);
        } else {
            setSnackBar("error", `Operation failed, please try again.`)
            setFullPageLoader(false);
        }
        setFullPageLoader(false);

    };

    // =================== Use Effects ===================
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get("token");
        const OTP = searchParams.get("OTP");

        if (token) {
            setEmail(atob(token));
        }
        if (OTP) {
            setOtp(atob(OTP));
        }
    }, [location.search]);

    return (
        <>
            <CommonAuth
                onButtonClick={handleChangePassword}
                submitButtonName={"Reset Password"}
                btnMarginTop={{ xs: "2rem", sm: "1rem", md: "1.5rem" }}
                boxShadow={"13px -5px 30px 0px rgba(29, 97, 205, 0.10)"}
                children={
                    <>
                        <Typography sx={{ fontSize: { xs: "20px", sm: "26px", md: "28px" }, color: "#131313", fontFamily: "Satoshi-Bold !important", mt: { xs: "10px", sm: "30px", md: "50px" }, }}                        >
                            Set a New Password
                        </Typography>
                        <Grid container spacing={3} mt={{ xs: 0, sm: 1, md: 1 }}>
                            <Grid item xs={12}>
                                <CommonTextField
                                    isPassword
                                    type={"password"}
                                    label={"New Password"}
                                    color={"#E77843 !important"}
                                    placeholder={"Enter New Password"}
                                    value={values.newPassword}
                                    onChange={onChangeHandler}
                                    name="newPassword"
                                />
                                <ErrorMessage text={errors.newPassword} />
                            </Grid>
                            <Grid item xs={12}>
                                <CommonTextField
                                    isPassword
                                    type={"password"}
                                    label={"Confirm Password"}
                                    color={"#E77843 !important"}
                                    placeholder={"Enter Confirm Password"}
                                    value={values.confirmPassword}
                                    onChange={onChangeHandler}
                                    name="confirmPassword"
                                />
                                <ErrorMessage text={errors.confirmPassword} />
                            </Grid>
                        </Grid>
                    </>
                }
                children2={
                    <>
                        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", margin: { xs: "1.5rem 0 0", sm: "2.5rem 0 1", md: "3rem 0 1rem", }, }} onClick={handleBack}>
                            <img src="/assets/img/backArrow.svg" />
                            <Typography sx={{ ml: 1, color: "#8D8D8D", fontSize: { xs: "14px", sm: "14px", md: "16px" }, fontWeight: "500", fontFamily: "Satoshi-Medium", }}>
                                Back To login
                            </Typography>
                        </Box>
                    </>
                }
            />
        </>
    );
};

export default EnterPassword;
